<div class="container-fluid p-0">
	<div class="row">
		<div class="col-12">
			<div class="login-card">
				<div>
					<div>
						<a class="logo" routerLink="/">
							<img
								class="img-fluid for-light"
								src="assets/images/logo/Tasyire-logo.png"
								alt="looginpage"
							/>
						</a>
					</div>
					<div class="login-main">
						<form class="theme-form" [formGroup]="passwordresetForm">
							<h4 translate>Password Reset</h4>
							<p>{{ 'Enter your email' | translate }}</p>
							<div class="form-group">
								<label class="col-form-label" translate>Email Address</label>
								<input
									class="form-control"
									type="email"
									required="true"
									placeholder="app@yourmail.com"
									formControlName="email"
								/>
								<div
									*ngIf="
										passwordresetForm.controls.email.touched &&
										passwordresetForm.controls.email.errors?.required
									"
									class="text text-danger mt-1"
								>
									{{ 'Email is required' | translate }}
								</div>
								<div
									*ngIf="
										passwordresetForm.controls.email.touched &&
										passwordresetForm.controls.email.errors?.email
									"
									class="text text-danger mt-1"
								>
									{{ 'Invalid Email' | translate }}
								</div>
							</div>

							<div class="form-group mb-0">
								<div class="checkbox p-0">
									<div class="text text-{{ messageResponse.type | translate }} mt-1">
										{{ messageResponse.message | translate }}
									</div>
								</div>
								<div class="text-end mt-3">
									<button
										class="btn btn-primary d-block w-100"
										[disabled]="!passwordresetForm.valid"
										(click)="Submit()"
										type="button"
									>
										<span translate>Submit</span>
									</button>
								</div>
							</div>
							<p class="mt-4 mb-0">
								<a [routerLink]="'../login'" class="ms-2">{{ 'Login' | translate }} </a>
							</p>
						</form>
					</div>
				</div>
			</div>
		</div>
	</div>
</div>
